<template>
    <div>
        <component v-bind:is="vueName"></component>
    </div>
</template>
<script>
import Error from './ErrorRouter.vue'

export default {
    name:'route',
    components: {
        Error,
        // krintroduceintroduce: () => import('@/views/kr/introduce/Introduce'),
        // krsecu_suppsecu_supp: () => import('@/views/kr/secu_supp/Secu_supp'),

        // krserviceinfraConsult: () => import('@/views/kr/service/InfraConsult'),
        // krserviceweakConsult: () => import('@/views/kr/service/WeakConsult'),
        // krserviceebankingConsult: () => import('@/views/kr/service/EbankingConsult'),
        // krservicecloudConsult: () => import('@/views/kr/service/CloudConsult'),

        // enintroduceintroduce: () => import('@/views/en/introduce/Introduce'),
        // ensecu_suppsecu_supp: () => import('@/views/en/secu_supp/Secu_supp'),
    },
    data: () => {
        return {
            langcode: '',
            menu: '',
            title: '',
            vueName: '',
        }
    },
    created: function() {
        // this.langcode = this.$route.params.langcode;
        this.menu = this.$route.params.menu;
        this.title = this.$route.params.title;
        // console.log(this)
        this.loadComponent();
    },
    methods: {
        loadComponent() {
                if(this.$route.name == 'krRoute') {
                    this.langcode = 'kr';
                } else {
                    this.langcode = 'en';
                }
                // this.vueName = this.langcode + this.menu + this.title;
                let vueTitle = this.title.charAt(0).toUpperCase() + this.title.slice(1);
                this.vueName = () => ({
                    component: import("@/views/" + this.langcode + "/" + this.menu + "/" + vueTitle),
                    loading: true,
                    error: Error,
                })
        }
    }
}

</script>